import { NotificationManager } from 'react-notifications';

export const createNotification = (type, title, message) => {
  switch (type) {
    case 'info':
      NotificationManager.info(title, message);
      break;
    case 'success':
      NotificationManager.success(title, message);
      break;
    case 'warning':
      NotificationManager.warning(title, message);
      break;
    case 'error':
      NotificationManager.error(title, message);
      break;
    default:
      break;
  }
}
